import { render, staticRenderFns } from "./Trigger.vue?vue&type=template&id=55e7364e&scoped=true&"
import script from "./Trigger.vue?vue&type=script&lang=js&"
export * from "./Trigger.vue?vue&type=script&lang=js&"
import style0 from "./Trigger.vue?vue&type=style&index=0&id=55e7364e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../demo/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e7364e",
  null
  
)

export default component.exports